// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.body_styles[data-v-7ab166b1] {
  gap: 15px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}
.body_style_card[data-v-7ab166b1] {
  border-radius: 10px;
}
.body_style_card i[data-v-7ab166b1] {
  font-size: 30px;
}
.body_style_card.disabledContent[data-v-7ab166b1] {
  pointer-events: none !important;
  opacity: 0.9 !important;
}
.body_style_card .cursor_pointer[data-v-7ab166b1] {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ChatWidget/AssistantAi/AiComponents/AiBodyStyles.vue","webpack://./AiBodyStyles.vue"],"names":[],"mappings":"AACA;EACE,SAAA;EACA,aAAA;EACA,qCAAA;ACAF;ADGA;EACE,mBAAA;ACDF;ADAA;EAII,eAAA;ACDJ;ADIE;EACE,+BAAA;EACA,uBAAA;ACFJ;ADPA;EAaI,eAAA;ACHJ","sourcesContent":["\n.body_styles {\n  gap: 15px;\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n}\n\n.body_style_card {\n  border-radius: 10px;\n\n  i {\n    font-size: 30px;\n  }\n\n  &.disabledContent {\n    pointer-events: none !important;\n    opacity: 0.9 !important;\n  }\n\n  .cursor_pointer {\n    cursor: pointer;\n  }\n\n}\n",".body_styles {\n  gap: 15px;\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n}\n.body_style_card {\n  border-radius: 10px;\n}\n.body_style_card i {\n  font-size: 30px;\n}\n.body_style_card.disabledContent {\n  pointer-events: none !important;\n  opacity: 0.9 !important;\n}\n.body_style_card .cursor_pointer {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
